import { useState, useEffect } from "react";
import "./admin-courses-creation.css";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../../../ui/atoms/buttons/Button";
import InputText from "../../../../ui/atoms/inputs/input-text/InputText";
import InputSelect from "../../../../ui/atoms/inputs/input-select/InputSelect";
import InputTextArea from "../../../../ui/atoms/inputs/input-textarea/InputTextArea";
import NotFound from "../../../../ui/organisms/not-found/404";
//
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
//
import { ChapterSchema } from "../../../../core/utils/validators/course";
import { capitalizeAll, wait } from "../../../../core/utils/helpers";
import { onCreateChapter } from "../../services/course";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";
//
import Swal from "sweetalert2";

const AdminCourseChaptersCreation = () => {
  const axiosPrivate = useAxiosPrivate();
  const { course_id } = useParams();
  const navigate = useNavigate();
  const [isSending, setIsSending] = useState(false);

  const currentCourse = useSelector(
    (state) => state?.schoolState?.currentCourse
  );
  const _course_id = currentCourse?.course_id;
  const _course_title = currentCourse?.course_title;

  useEffect(() => {
    if (course_id !== _course_id) {
      return <NotFound type={"page"} />;
    }
  }, [course_id]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    resolver: yupResolver(ChapterSchema),
    defaultValues: {
      course_id: _course_id,
    },
  });

  const onSubmit = async (data) => {
    setIsSending(true);
    Swal.fire({
      title: "Creating new course's chapter...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    await wait(700);
    //
    onCreateChapter(axiosPrivate, data)
      .then((response) => {
        const _data = response?.data;
        Swal.close();
        setIsSending(false);

        if (_data?.status) {
          Swal.fire({
            title: "Course's Chapter creation",
            text: _data?.message,
            icon: "success",
            confirmButtonText: "OK",
            didOpen: () => {
              const btn = Swal.getConfirmButton(); //
              btn.style.backgroundColor = "#2840a8";
              btn.style.color = "white";
            },
          });
          reset();
        } else {
          Swal.fire({
            title: "Course's Chapter creation",
            text: _data?.message,
            icon: "info",
          });
        }
      })
      .catch((error) => {
        setIsSending(false);
        Swal.close();
        if (!error?.response) {
          Swal.fire({
            title: "Course's Chapter creation",
            text: "No server response",
            icon: "warning",
          });
        } else {
          Swal.fire({
            title: "Course's Chapter creation",
            text: error?.response?.data?.detail?.message,
            icon: "error",
          });
        }
      });
  };

  return (
    <form className="school-creation" onSubmit={handleSubmit(onSubmit)}>
      <div className="sc-cr-head">
        <button type="button" onClick={() => navigate(-1)}>
          ⬅️ Back to list
        </button>
        <div className="w-full d-flex justify-space-between align-center">
          <h1>📖 New Chapter Creation</h1>
          <Button
            type={isSending ? "button" : "submit"}
            preferedStyle={isSending ? "default" : "normal"}
            title={
              isSending
                ? "Creating new chapter..."
                : "Validate and Create new chapter"
            }
          />
        </div>
      </div>
      <div className="sc-cr-body">
        <div className="w-full mb-lg">
          <h2>Course : {capitalizeAll(_course_title)}</h2>
        </div>
        <div className="w-full d-flex gap-md mb-lg">
          <div className="w-50">
            <InputText
              type={"text"}
              name={"title"}
              title={"Title"}
              error={errors?.title?.message}
              register={register}
            />
          </div>
          <div className="w-50">
            <InputSelect
              name={"language"}
              error={errors?.language?.message}
              register={register}
              data={[
                { key: "en", title: "English", is_activated: false },
                { key: "fr", title: "French", is_activated: false },
              ]}
              placeholder={"Select language"}
            />
          </div>
        </div>
        <div className="w-full">
          <InputTextArea
            name={"description"}
            title={"Description"}
            error={errors?.description?.message}
            register={register}
          />
        </div>
      </div>
    </form>
  );
};

export default AdminCourseChaptersCreation;
